import useClickOutside from '@/components/useClickOutSide';
import Text from 'atoms/Text';
import { useRouter } from 'hooks/navigation-router-with-loading';
import Image from 'molecules/Image';
import { useRef, useState } from 'react';

function SwitchProfile({ active = 'manager', session, onClose }) {
    const [show, setShow] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const isAdminOrRM = ['admin', 'super_admin', 'resource_manager', 'resource_manager_lead', 'guest_rm', 'talent_advisor', 'business_team', 'tpcr_rm', 'tpcr_rm_lead'].some((role) => session?.user?.role?.includes(role));
    const isTalentAdvisor = session?.user?.role?.includes('talent_advisor');
    const isPodLead = session?.user?.role?.includes('pod_lead');
    const isResource = session?.user?.gradeLevel === 'resource' && !isAdminOrRM
    const isSLLead = session?.user?.role?.includes('service_line_lead');
    const isSCLead = session?.user?.role?.includes('service_category_lead');
    const ref = useRef();
    const managerModeRedirectPath = () => {
        if (isTalentAdvisor) return '/requisitions'
        if (isResource) {
            if (isPodLead) return '/work-packages-pod-lead'
            if (isSCLead || isSLLead) return '/work-packages'
        }

        return '/'
    }
    useClickOutside(ref, () => {
        setShow(false);
        //setShowSwitch(false);
    });
    const router = useRouter();
    const employeeMode = {
        id: 2,
        label: 'Employee Mode',
        icon: '/assets/icons/resource-icon.svg',
        isActive: active === 'resource',
        onClick: () => {
            setShow(!show);
            setShowLoader(true);
            router.push('/resource-dashboard');
        }
    };

    const managerMode = {
        id: 1,
        label: 'Manager Mode',
        icon: '/assets/icons/resource-manager.svg',
        isActive: active === 'manager',
        onClick: () => {
            setShow(!show);
            setShowLoader(true);
            const redirectPath = managerModeRedirectPath()
            router.push(redirectPath);
        }
    };
    const lists = [employeeMode, managerMode];
    // const cookieSwitchvalue = Cookies.get('sapSwiftSwitch');
    // const [showSwitch, setShowSwitch] = useState(false);
    // const [switchValue, setSwitchValue] = useState(cookieSwitchvalue || 'sap');
    // const switchList = [
    //     {
    //         id: 2,
    //         label: 'SAP',
    //         icon: '/assets/icons/prj_icon.svg',
    //         isActive: switchValue === 'sap',
    //         onClick: () => {
    //             setShowSwitch(!showSwitch)
    //             setSwitchValue('sap');
    //             //setShowLoader(true);
    //             setCookie('sapSwiftSwitch', 'sap');
    //         }
    //     },
    //     {
    //         id: 1,
    //         label: 'Swift',
    //         icon: '/assets/icons/available.svg',
    //         isActive: switchValue === 'swift',
    //         onClick: () => {
    //             setShowSwitch(!showSwitch)
    //             setSwitchValue('swift');
    //             //setShowLoader(true);
    //             setCookie('sapSwiftSwitch', 'swift');
    //         }
    //     }
    // ];

    return (
        <div ref={ref} className='fixed top-0 right-12 sm:right-[6rem] z-[997] h-12 flex items-center justify-center'>
            <div className='cursor-pointer w-10 h-10 opacity-70 flex items-center justify-center hover:bg-[#292929] p-3'
                onClick={() => setShow(!show)}>
                <Image
                    src={`/assets/icons/${active === 'resource' ? 'resource-icon.svg' : 'resource-manager.svg'}`}
                    width={32}
                    height={32}
                    alt='resource'
                />
            </div>
            {/* <div className='cursor-pointer w-10 h-10 opacity-70 flex items-center justify-center hover:bg-[#292929] p-3'
                onClick={() => setShowSwitch(!showSwitch)}>
                <Image
                    src={`/assets/icons/prj_icon.svg}`}
                    width={32}
                    height={32}
                    alt='resource'
                />
            </div> */}
            {
                show && (
                    <div className="absolute flex top-12 right-0 shadow-lg w-[210px] justify-between bg-black text-white z-[199]">
                        <div className='flex flex-col p-4 gap-2'>
                            {
                                lists.map((item) => (
                                    <div
                                        key={item.id}
                                        className={`flex items-center gap-2 text-sm cursor-pointer text-base hover:opacity-100 transition-all ${!item.isActive ? 'opacity-60' : 'pointer-events-none'}`}
                                        onClick={item.onClick}
                                    >
                                        <i className={`h-4 w-4 block rounded-full border-white border border-1 ${item.isActive ? 'bg-green-900' : ''}`} ></i>
                                        <div className='w-8 h-8 flex items-center justify-center'>
                                            <Image
                                                src={item.icon}
                                                width={20}
                                                height={20}
                                                alt='icon'
                                            />
                                        </div>
                                        {item.label}
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                )
            }
            {/* {
                showSwitch && (
                    <div className="absolute flex top-12 right-0 shadow-lg w-[210px] justify-between bg-black text-white z-[199]">
                        <div className='flex flex-col p-4 gap-2'>
                            {
                                switchList.map((item) => (
                                    <div
                                        key={item.id}
                                        className={`flex items-center gap-2 text-sm cursor-pointer text-base hover:opacity-100 transition-all ${!item.isActive ? 'opacity-60' : 'pointer-events-none'}`}
                                        onClick={item.onClick}
                                    >
                                        <i className={`h-4 w-4 block rounded-full border-white border border-1 ${item.isActive ? 'bg-green-900' : ''}`} ></i>
                                        <div className='w-8 h-8 flex items-center justify-center'>
                                            <Image
                                                src={item.icon}
                                                width={20}
                                                height={20}
                                                alt='icon'
                                            />
                                        </div>
                                        {item.label}
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                )
            } */}
            {
                showLoader && (
                    <div className='fixed top-12 left-0 w-full h-[calc(100vh-3rem)] bg-white bg-opacity-90 z-[1000] flex items-center justify-center flex-col gap-4'>
                        <Image
                            src='/assets/icons/reload.svg'
                            width={48}
                            height={48}
                            alt='reload'
                        />
                        <Text>Please wait, switching to your profile</Text>
                    </div>
                )
            }
        </div >
    );
}

export default SwitchProfile;
